import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useInitialStepStore } from "../../hooks/useInitialStepStore";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../types/api/status";


import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { RoutesMap } from "../../types";

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'order', label: 'N° Orden', align: 'center' },
    { type: 'text', field: 'initialStep', label: 'Descripción', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Planes', pathname: RoutesMap.PLANS_LIST },
    { id: 3, label: 'Orden de pasos iniciales', pathname: RoutesMap.PLAN_INITIAL_STEP_LIST },
]

export const PlanInitialStepList: FC = () => {

    const params = useParams()
    const { key } = params

    const { status, detInitialSteps, getDetailInitialStep, changeOrderStep } = useInitialStepStore()

    useEffect(() => {
        getDataApi()
    }, [])

    const getDataApi = async () => {
        await getDetailInitialStep({ plan: key })
    }

    const onUpStep = async (rowSelected) => {
        const response = await changeOrderStep({
            iddet_initial_setp: rowSelected.id,
            order: 'up'
        })
        if (response === true) getDataApi()
    }

    const onDownStep = async (rowSelected) => {
        const response = await changeOrderStep({
            iddet_initial_setp: rowSelected.id,
            order: 'down'
        })
        if (response === true) getDataApi()
    }

    return (<>
        <CustomTable
            breadcrumbs={breadcrumbs}
            title={'Orden de pasos inciales'}
            columns={columns}
            loading={status === ApiStatus.FETCHING}
            rows={detInitialSteps || []}
            onRowClick={() => { }}
            hasOptions
            onHelper={onUpStep}
            tooltip_helper={'Subir prioridad'}
            icon_helper={<KeyboardArrowUpIcon fontSize="small" />}
            onHelper2={onDownStep}
            tooltip_helper2={'Bajar prioridad'}
            icon_helper2={<KeyboardArrowDownIcon fontSize="small" />}
            dense
        />
    </>)
}